var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('g',{attrs:{"transform":"translate(670, -490)"}},[_c('logoutButton')],1),_c('text',{staticClass:"txt",attrs:{"x":"0","y":"-10","text-anchor":"middle","dominant-baseline":"middle","font-family":"sans-serif","font-size":"50","fill":"#000000"}},[_vm._v(_vm._s(_vm.$shared.text.study_closed))])])
}
var staticRenderFns = []

export { render, staticRenderFns }